<mat-list-item class="py-2 bg-lightest" matTooltipPosition="right" [matTooltip]="'Package: ' + (package?.title ?? 'None')" [matTooltipDisabled]="isExpanded">
  <div class="w-100 fx-row y-center fx-gap-sm" [class.x-center]="!isExpanded">

    @if (package) {
      <img [isSmall]="true" [isVip]="isVIP" [lcBadge]="package">
    }
    @if (!package) {
      <mat-icon class="size-34">hide_source</mat-icon>
    }

    @if (isExpanded) {
      <div class="fx-1-1-0">
        <div class="package-name mat-body-2 text-bold text-uppercase line-height-0">{{package?.title ?? 'None'}}</div>
        <div class="package-label mat-caption line-height-0">Package</div>
      </div>
    }

    @if (isExpanded && editLink) {
      <a class="xs" id="edit-package" mat-icon-button [replaceUrl]="replaceUrl" [routerLink]="editLink">
        <mat-icon>edit</mat-icon>
      </a>
    }
  </div>
</mat-list-item>
